/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import OpMedication from './op-medication';
import OpMedicationDetail from './op-medication-detail';
import OpMedicationUpdate from './op-medication-update';
import OpMedicationDeleteDialog from './op-medication-delete-dialog';

const OpMedicationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<OpMedication />} />
    <Route path="new" element={<OpMedicationUpdate />} />
    <Route path=":id">
      <Route index element={<OpMedicationDetail />} />
      <Route path="edit" element={<OpMedicationUpdate />} />
      <Route path="delete" element={<OpMedicationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default OpMedicationRoutes;
